import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import { Link, useParams } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import dateFormat from "dateformat";
import logo from "../../assets/images/logo.svg";
import { addNoteToRentOrder, viewOrdersRentalDetails } from "../../redux/action/rentVehicle";
import loader from "../../components/loader/loader";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";

const EditOrderRentals = ({ pageLoading, orderRentalsList, not_found }) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  useEffect(() => {
    dispatch(viewOrdersRentalDetails(id));
  }, [dispatch, id]);

  const rentalsDetails = orderRentalsList?.data
    ? orderRentalsList?.data?.rentVehicle
    : "";

  const childSeatData = [
    {
      name: "Child Seat",
      price: 10,
    },
    {
      name: "Roadside Assistance",
      price: 20,
    },
    {
      name: "Mobile Phone",
      price: 30,
    },
  ];

  // pdf code start
  const downloadPDF = () => {
    const capture = document.querySelector(".pdfview");
    html2canvas(capture).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      console.log("Image Data:", imgData); // Debugging: Log the image data
      const doc = new jsPDF("p", "mm", "a4");
      const imgWidth = 200; // Adjust this based on your needs
      const imgHeight = (imgWidth * canvas.height) / canvas.width; // Maintain aspect ratio
      doc.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      doc.save("roadside-response.pdf");
    });
  };
  // pdf code end

  const [noteValue, setNoteValue] = useState("");
  const [note, setNote] = useState("");


  const addNote = () => {
    const payload = {
      notes: noteValue,
      rentVehicleId: id,
    };
    if (!id) return;
    if (!payload?.notes) {
      toast.error("Please enter valid notes!");
      return;
    }
    dispatch(
      addNoteToRentOrder(payload, (type) => {
        if (type === "success") {
          // setSuccessNotes(true);
          toast.success("Note added successfully!");
          dispatch(viewOrdersRentalDetails(id));
          setNote("");
          setTimeout(() => {
            setNoteValue();
          }, 1000);
        }
      })
    );
  };


  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />

      <Layout title="View Order Rentals" page="viewOrderDetail">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div className="d-flex justify-content-between">
            <div></div>
            <div className="ms-3">
              <a
                className="btn pgf btn-secondary dropdown-toggle"
                href="#"
                // role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                // className="csvlink"
                style={{ background: "none" }}
              >
                Download File
              </a>

              <ul className="dropdown-menu">
                <li>
                  <a className="dropdown-item" onClick={downloadPDF}>
                    Download as PDF
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div id="kt_content_container row" className="container-fluid">
            {!pageLoading && rentalsDetails?.id ? (
              <div className="row pdfview">
                <div className="col-xl-8 mb-5">
                  <div className="card">
                    <div className="card-body p-lg-20">
                      <div className="d-flex flex-column flex-xl-row">
                        <div className="flex-lg-row-fluid me-xl-18 mb-10 mb-xl-0">
                          <div className="mt-n1">
                            <div className="d-flex flex-stack pb-10">
                              <Link to="#">
                                <img alt="Logo" src={logo} />
                              </Link>
                            </div>
                            <div className="m-0">
                              <div className="fw-bolder fs-3 text-gray-800 mb-8">
                                Order number #{rentalsDetails?.invoice_no}
                              </div>
                              <div className="row g-5 mb-12">
                                <div className="col-sm-6">
                                  <div className="fw-bolder fs-6 text-gray-800">
                                    Request by:
                                  </div>
                                  <div className="fw-bold fs-7 text-gray-600">
                                    {rentalsDetails?.customer_id?.firstName
                                      ? `${rentalsDetails?.customer_id?.firstName
                                        ? rentalsDetails?.customer_id
                                          ?.firstName
                                        : ""
                                      } ${rentalsDetails?.customer_id?.lastName
                                        ? rentalsDetails?.customer_id
                                          ?.lastName
                                        : ""
                                      }`
                                      : "N/A"}
                                  </div>
                                </div>
                                {/* <div className="col-sm-6">
                                <div className="fw-bolder fs-6 text-gray-800">
                                  Issued By:
                                </div>
                                <div className="fw-bold fs-7 text-gray-600">
                                  Roadside
                                </div>
                              </div> */}
                              </div>
                              <div className="flex-grow-1">
                                <div className="table-responsive border-bottom mb-9 w-100">
                                  <table
                                    className="table mb-3"
                                    style={{ width: "max-content" }}
                                  >
                                    <thead>
                                      <tr className="border-bottom fs-6 fw-bolder text-muted">
                                        <th className="min-w-70px pb-2">
                                          Date Rented from
                                        </th>
                                        <th className="min-w-70px pb-2">
                                          Date rented up to
                                        </th>
                                        <th className="min-w-70px pb-2">
                                          Total Days
                                        </th>
                                        <th
                                          className="pb-2"
                                          style={{ width: "170px" }}
                                        >
                                          Payment plan chosen
                                        </th>
                                        {/* <th
                                          className="pb-2"
                                          style={{ width: "70px" }}
                                        >
                                          Amount
                                        </th> */}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr className="fw-bolder text-gray-700 fs-5">
                                        <td className="pt-6">
                                          {rentalsDetails?.fromDate
                                            ? rentalsDetails?.fromDate
                                            : "N/A"}
                                        </td>
                                        <td className="pt-6">
                                          {rentalsDetails?.toDate
                                            ? rentalsDetails?.toDate
                                            : "N/A"}
                                        </td>
                                        <td className="pt-6">
                                          {rentalsDetails?.totalDays
                                            ? rentalsDetails?.totalDays
                                            : rentalsDetails?.perWeek
                                              ? rentalsDetails?.perWeek
                                              : "N/A"}
                                        </td>
                                        <td className="pt-6">
                                          {/* {rentalsDetails?.price
                                            ? `$${rentalsDetails?.price}`
                                            : "N/A"} */}
                                          {rentalsDetails?.perWeekPrice ==
                                            undefined
                                            ? rentalsDetails?.price
                                              ? `$${rentalsDetails?.price}/per day`
                                              : "N/A"
                                            : rentalsDetails?.perWeekPrice
                                              ? `$${rentalsDetails?.perWeekPrice}/per week`
                                              : "N/A"}
                                        </td>
                                        <td className="pt-6 text-dark fw-boldest">
                                          {/* {rentalsDetails?.perWeekPrice ==
                                          undefined
                                            ? rentalsDetails?.totalPrice
                                              ? `$${rentalsDetails?.totalPrice}`
                                              : "N/A"
                                            : rentalsDetails?.perWeekTotalPrice
                                            ? `$${rentalsDetails?.perWeekTotalPrice}`
                                            : "N/A"} */}
                                        </td>
                                      </tr>
                                    </tbody>
                                    <thead>
                                      <tr className="border-bottom fs-6 fw-bolder text-muted">
                                        <th className="pb-2">Start time</th>
                                        <th className="pb-2">End time</th>
                                        {/* <th className="pb-2">Pick Time</th>
                                        <th className="pb-2">Drop off Time</th> */}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr className="fw-bolder text-gray-700 fs-5 text-end">
                                        <td className="pt-6">
                                          {rentalsDetails?.startTime
                                            ? rentalsDetails?.startTime
                                            : "N/A"}
                                        </td>
                                        <td className="pt-6">
                                          {rentalsDetails?.endTime
                                            ? rentalsDetails?.endTime
                                            : "N/A"}
                                        </td>
                                      </tr>
                                    </tbody>
                                    <tr className="border-top border-bottom">
                                      <div className="py-4 fw-bolder text-gray-800 fs-5">
                                        <span className="p-0">
                                          Details of Add On's Selected:
                                        </span>
                                      </div>
                                    </tr>
                                    <thead>
                                      <tr className="border-bottom fs-6 fw-bolder text-muted">
                                        {rentalsDetails?.rent &&
                                          rentalsDetails?.rent?.map((val) => {
                                            return (
                                              <th className="pb-2">
                                                {val?.addName}
                                              </th>
                                            );
                                          })}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr className="fw-bolder text-gray-700 fs-5 text-end">
                                        {rentalsDetails?.rent &&
                                          rentalsDetails?.rent?.map((val) => {
                                            return (
                                              <td className="pt-3 align-baseline">
                                                {val?.quantity > 0
                                                  ? (
                                                    <tr className="fw-bolder text-gray-700 fs-6 text-end">
                                                      <td className="p-0">
                                                        Quantity :
                                                      </td>
                                                      <td className="p-0 px-1">
                                                        {val?.quantity
                                                          ? val?.quantity
                                                          : "N/A"}
                                                      </td>
                                                    </tr>
                                                  ) : (
                                                    ""
                                                  )}
                                                <tr className="fw-bolder text-gray-700 fs-6 text-end">
                                                  <td className="p-0">
                                                    Price :
                                                  </td>
                                                  <td className="p-0 px-1">
                                                    {val?.price
                                                      ? `$${val?.price}`
                                                      : "N/A"}
                                                  </td>
                                                </tr>
                                              </td>
                                            );
                                          })}
                                      </tr>
                                    </tbody>
                                    <thead>
                                      <tr className="border-bottom fs-6 fw-bolder text-muted">
                                        <th className="pb-2">Pick Time</th>
                                        <th className="pb-2">Drop off Time</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr className="fw-bolder text-gray-700 fs-5 text-end">
                                        <td className="pt-6">
                                          {rentalsDetails?.createdAt
                                            ? dateFormat(
                                              rentalsDetails?.createdAt,
                                              "mm/dd/yyyy HH:mm:ss"
                                            )
                                            : "N/A"}
                                        </td>
                                        <td className="pt-6">
                                          {rentalsDetails?.createdAt
                                            ? dateFormat(
                                              rentalsDetails?.createdAt,
                                              "mm/dd/yyyy HH:mm:ss"
                                            )
                                            : "N/A"}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div className="d-flex justify-content-end">
                                  <div className="mw-300px">
                                    <div className="d-flex flex-stack mb-3">
                                      <div className="fw-bold pe-10 text-gray-600 fs-7">
                                        Total :
                                      </div>
                                      <div className="text-end fw-bolder fs-6 text-gray-800">
                                        {rentalsDetails?.totalPrice
                                          ? `$${rentalsDetails?.totalPrice}`
                                          : rentalsDetails?.perWeekTotalPrice
                                            ? `$${rentalsDetails?.perWeekTotalPrice}`
                                            : "N/A"}
                                      </div>
                                    </div>
                                  </div>
                                </div>


                                <div className="row mb-8 mt-5">
                                  <div className="col-xl-2">
                                    <div className="fs-6 fw-bold mt-2 mb-3">
                                      Note :
                                    </div>
                                  </div>
                                  <div className="col-xl-8 fv-row fv-plugins-icon-container">
                                    <input
                                      type="text"
                                      className="form-control form-control-solid"
                                      onChange={(e) =>
                                        setNoteValue(e?.target?.value)
                                      }
                                      name="notes"
                                      id="notes"
                                      value={noteValue}
                                    />
                                  </div>
                                  <div className="col-xl-2 fv-row fv-plugins-icon-container">
                                    <button
                                      type="btn"
                                      onClick={() => addNote()}
                                      className="btn btn-primary d-flex"
                                      style={{ marginLeft: "auto" }}
                                    >
                                      <span className="indicator-label">Add</span>
                                    </button>
                                  </div>
                                </div>


                                {rentalsDetails?.notes?.length > 0 && (
                                <div className="notes-list">
                                  <ul className="">
                                    {rentalsDetails?.notes?.length > 0 &&
                                      rentalsDetails?.notes?.map((val, ind) => {
                                        return (
                                          <li
                                            className="list-group-item notes-item"
                                            key={ind}
                                          >
                                            <p className="fs-7 text-gray-600 float-right mb-2 d-flex justify-content-between">
                                              <span>Commented at</span>
                                              <span>
                                                {val?.createdAt
                                                  ? dateFormat(
                                                      val?.createdAt,
                                                      "dddd, dd/mm/yyyy, h:MM TT"
                                                    )
                                                  : ""}
                                              </span>
                                            </p>
                                            <p className="fs-6 fw-bold mb-2 d-flex">
                                              <span
                                                style={{ color: "#ff4e00" }}
                                                className="me-2"
                                              >
                                                *
                                              </span>
                                              {val?.note}
                                            </p>
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 mb-5">
                    <div className="d-print-none border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten">
                      <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                        VEHICLE DETAILS
                      </h6>
                      <div className="row mb-5">
                        <div className="col-md-3 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Vehicle Name</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {rentalsDetails?.vehicle_id?.name
                              ? rentalsDetails?.vehicle_id?.name
                              : "N/A"}
                          </div>
                        </div>
                        <div className="col-md-3 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Vehicle Model</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {rentalsDetails?.vehicle_id?.vehicle_model
                              ? rentalsDetails?.vehicle_id?.vehicle_model
                              : "N/A"}
                          </div>
                        </div>
                        <div className="col-md-3 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Registration No</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {rentalsDetails?.vehicle_id?.registration_no
                              ? rentalsDetails?.vehicle_id?.registration_no
                              : "N/A"}
                          </div>
                        </div>
                        <div className="col-md-3 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Vehicle Color</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {rentalsDetails?.vehicle_id?.color
                              ? rentalsDetails?.vehicle_id?.color
                              : "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="mt-5 mb-5">
                    <div className="d-print-none border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten">
                      <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                        Add on Details
                      </h6>
                      <div className="row mb-5">
                        <div className="col-md-4 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Child Seat</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            $
                            {rentalsDetails?.childPrice
                              ? rentalsDetails?.childPrice
                              : "N/A"}
                          </div>
                        </div>
                        <div className="col-md-4 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Mobile Phone</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            $
                            {rentalsDetails?.mobilePrice
                              ? rentalsDetails?.mobilePrice
                              : "N/A"}
                          </div>
                        </div>
                        <div className="col-md-4 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Roadside Assistance</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            $
                            {rentalsDetails?.driverPrice
                              ? rentalsDetails?.driverPrice
                              : "N/A"}
                          </div>
                        </div>
                        <div className="col-md-4 fv-row fv-plugins-icon-container pt-5">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Pick Time</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {rentalsDetails?.createdAt
                              ? dateFormat(
                                  rentalsDetails?.createdAt,
                                  "mm/dd/yyyy HH:mm:ss"
                                )
                              : "N/A"}
                          </div>
                        </div>
                        <div className="col-md-4 fv-row fv-plugins-icon-container pt-5">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Drop off Time</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {rentalsDetails?.createdAt
                              ? dateFormat(
                                  rentalsDetails?.createdAt,
                                  "mm/dd/yyyy HH:mm:ss"
                                )
                              : "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="m-0 col-xl-4">
                  <div className="mb-4">
                    <div className="d-print-none border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten">
                      <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                        PAYMENT DETAILS
                      </h6>
                      <div className="mb-6">
                        <div className="fw-bolder text-gray-800 fs-6">
                          Stripe
                        </div>
                        <div className="fw-bold text-gray-600 fs-7">
                          {` Card Type : ${rentalsDetails?.purchase_id
                            ?.rentVehcile_transition?.[0]?.transition?.[0]
                            ?.payment_method_details?.card?.brand
                            ? rentalsDetails?.purchase_id
                              ?.rentVehcile_transition?.[0]?.transition?.[0]
                              ?.payment_method_details?.card?.brand
                            : "N/A"
                            }`}
                        </div>
                        <div className="fw-bold text-gray-600 fs-7">
                          {` Country : ${rentalsDetails?.purchase_id
                            ?.rentVehcile_transition?.[0]?.transition?.[0]
                            ?.payment_method_details?.card?.country
                            ? rentalsDetails?.purchase_id
                              ?.rentVehcile_transition?.[0]?.transition?.[0]
                              ?.payment_method_details?.card?.country
                            : "N/A"
                            }`}
                        </div>
                        <div className="fw-bold text-gray-600 fs-7">
                          {` Card Details : ${rentalsDetails?.purchase_id
                            ?.rentVehcile_transition?.[0]?.transition?.[0]
                            ?.payment_method_details?.card?.last4
                            ? `**** **** ****`
                            : ""
                            } ${rentalsDetails?.purchase_id
                              ?.rentVehcile_transition?.[0]?.transition?.[0]
                              ?.payment_method_details?.card?.last4
                              ? rentalsDetails?.purchase_id
                                ?.rentVehcile_transition?.[0]?.transition?.[0]
                                ?.payment_method_details?.card?.last4
                              : ""
                            }`}
                        </div>
                        <div className="fw-bold text-gray-600 fs-7">
                          {` Card expiration time : ${rentalsDetails?.purchase_id
                            ?.rentVehcile_transition?.[0]?.transition?.[0]
                            ?.payment_method_details?.card?.exp_month
                            ? rentalsDetails?.purchase_id
                              ?.rentVehcile_transition?.[0]?.transition?.[0]
                              ?.payment_method_details?.card?.exp_month
                            : ""
                            }${rentalsDetails?.purchase_id
                              ?.rentVehcile_transition?.[0]?.transition?.[0]
                              ?.payment_method_details?.card?.exp_month
                              ? `/`
                              : ""
                            }${rentalsDetails?.purchase_id
                              ?.rentVehcile_transition?.[0]?.transition?.[0]
                              ?.payment_method_details?.card?.exp_year
                              ? rentalsDetails?.purchase_id
                                ?.rentVehcile_transition?.[0]?.transition?.[0]
                                ?.payment_method_details?.card?.exp_year
                              : ""
                            }`}
                        </div>
                        <div className="fw-bold text-gray-600 fs-7">
                          {` Customer Email : ${rentalsDetails?.purchase_id
                            ?.rentVehcile_transition?.[0]?.transition?.[0]
                            ?.receipt_email
                            ? rentalsDetails?.purchase_id
                              ?.rentVehcile_transition?.[0]?.transition?.[0]
                              ?.receipt_email
                            : "N/A"
                            }`}
                        </div>
                      </div>
                      <div className="mb-6">
                        <div className="fw-bold text-gray-600 fs-7">
                          Payment Term:
                        </div>
                        <div className="fw-bolder fs-6 text-gray-800 d-flex align-items-center">
                          14 days
                          <span className="fs-7 text-danger d-flex align-items-center">
                            <span className="bullet bullet-dot bg-danger mx-2"></span>
                            Due in 7 days
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 mb-5">
                    <div className="d-print-none border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten mb-5">
                      <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                        CUSTOMER DETAILS
                      </h6>
                      <div className="row mb-5">
                        <div className="col-md-6 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>User Name</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {rentalsDetails?.customer_id?.firstName
                              ? rentalsDetails?.customer_id?.firstName +
                              " " +
                              rentalsDetails?.customer_id?.lastName
                              : "N/A"}
                          </div>
                        </div>
                        <div className="col-md-6 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Phone Number </span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {rentalsDetails?.customer_id?.phone
                              ? rentalsDetails?.customer_id?.phone
                              : "N/A"}
                          </div>
                        </div>
                      </div>
                      <div className="row mb-5">
                        <div className="col-md-6 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Date</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {rentalsDetails?.createdAt
                              ? dateFormat(
                                rentalsDetails?.createdAt,
                                "d mmmm , yyyy"
                              )
                              : "N/A"}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 fv-row fv-plugins-icon-container mb-5">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Email Address</span>
                        </label>
                        <div className="fw-bold text-gray-600 fs-7">
                          {rentalsDetails?.customer_id?.email
                            ? rentalsDetails?.customer_id?.email
                            : "N/A"}
                        </div>
                      </div>
                      <div className="row mb-5">
                        {/* <div className="col-md-6 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>City</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {rentalsDetails?.customer_id?.address?.[0]?.city
                              ? rentalsDetails?.customer_id?.address?.[0]?.city
                              : " N/A"}
                          </div>
                        </div> */}
                        {/* <div className="col-md-6 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>State</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {rentalsDetails?.customer_id?.address?.[0]?.state
                              ? rentalsDetails?.customer_id?.address?.[0]?.state
                              : "N/A"}
                          </div>
                        </div> */}
                      </div>
                      <div className="row mb-5">
                        {/* <div className="col-md-6 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Street No</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {rentalsDetails?.customer_id?.address?.[0]
                              ?.street_no
                              ? rentalsDetails?.customer_id?.address?.[0]
                                  ?.street_no
                              : "N/A"}
                          </div>
                        </div> */}
                        <div className="col-md-6 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Address</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {rentalsDetails?.customer_id?.address?.[0]?.address
                              ? rentalsDetails?.customer_id?.address?.[0]
                                ?.address
                              : "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              loader()
            )}
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  pageLoading: state?.rentVehicle?.loading,
  orderRentalsList: state?.rentVehicle?.list,
  not_found: state?.rentVehicle?.not_found,
});

export default connect(mapStateToProps, { viewOrdersRentalDetails })(
  EditOrderRentals
);
